module.exports = __webpack_public_path__ + "static/media/galerija_2019 (9).94e9e575.jpg";